import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { useScroll } from '../context/ScrollContext'
import NotificationDropdown from './NotificationDropdown'

function Navbar() {
    const { user, logout } = useAuth()
    const { isScrolled } = useScroll()
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()

    const isDashboard = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/admin')
    // The /register page is a full-bleed split-screen that owns its own chrome;
    // fade the navbar out so it doesn't get visibly "covered" during the route transition.
    const isRegister = location.pathname === '/register'

    if (isDashboard) return null

    const dashboardPath = user?.role === 'admin'
        ? '/admin'
        : user?.role === 'business'
            ? '/dashboard/business'
            : '/dashboard/influencer'

    const handleLogout = async () => {
        await logout()
        navigate('/')
    }

    return (
        <nav
            className={`navbar${isScrolled ? ' navbar--scrolled' : ''}${isRegister ? ' navbar--hidden' : ''}`}
            aria-hidden={isRegister}
        >
            <div className="navbar__container">
                <Link to="/" className="navbar__logo">
                    <img
                        src="/postpaid-logo.png"
                        alt="PostPaid"
                        style={{ height: '138px', width: 'auto', display: 'block', marginTop: '14px' }}
                    />
                </Link>

                {!isDashboard && (
                    <div className="navbar__nav">
                        <Link to="/creators" className="navbar__link">
                            For Creators
                        </Link>
                        <Link to="/brands" className="navbar__link">
                            For Brands
                        </Link>
                        <Link to="/how-it-works" className="navbar__link">
                            How it works
                        </Link>
                        <Link to="/pricing" className="navbar__link">
                            Pricing
                        </Link>
                        <Link to="/guides" className="navbar__link">
                            Guides
                        </Link>
                        <Link to="/blog" className="navbar__link">
                            Blog
                        </Link>
                    </div>
                )}

                <div className="navbar__actions">
                    <div className="desktop-actions" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        {user ? (
                            <>
                                <NotificationDropdown user={user} />

                                <Link
                                    to={dashboardPath}
                                    className="btn btn--white btn--small"
                                    style={{ textDecoration: 'none', color: 'var(--accent)' }}
                                >
                                    Dashboard
                                </Link>
                                <button
                                    onClick={handleLogout}
                                    className="btn btn--outline-white btn--small"
                                >
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" className="btn btn--outline-white btn--small">
                                    Login
                                </Link>
                                <Link to="/register" className="btn btn--secondary btn--small">
                                    Sign Up
                                </Link>
                            </>
                        )}
                    </div>

                    <button
                        className="mobile-menu-btn"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        style={{ zIndex: 1001 }}
                        aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
                        aria-expanded={mobileMenuOpen}
                    >
                        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {
                mobileMenuOpen && (
                    <div className="mobile-menu">
                        {!isDashboard && (
                            <div className="mobile-menu__nav">
                                <Link to="/creators" className="mobile-menu__link" onClick={() => setMobileMenuOpen(false)}>
                                    For Creators
                                </Link>
                                <Link to="/brands" className="mobile-menu__link" onClick={() => setMobileMenuOpen(false)}>
                                    For Brands
                                </Link>
                                <Link to="/how-it-works" className="mobile-menu__link" onClick={() => setMobileMenuOpen(false)}>
                                    How it works
                                </Link>
                                <Link to="/pricing" className="mobile-menu__link" onClick={() => setMobileMenuOpen(false)}>
                                    Pricing
                                </Link>
                                <Link
                                    to="/guides"
                                    className="mobile-menu__link"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    Guides
                                </Link>
                                <Link
                                    to="/blog"
                                    className="mobile-menu__link"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    Blog
                                </Link>
                            </div>
                        )}
                        <div className="mobile-menu__actions">
                            {user ? (
                                <>
                                    <Link
                                        to={dashboardPath}
                                        className="btn btn--white btn--full"
                                        onClick={() => setMobileMenuOpen(false)}
                                        style={{ textDecoration: 'none', color: 'var(--accent)', marginBottom: '0.5rem' }}
                                    >
                                        Dashboard
                                    </Link>
                                    <button
                                        onClick={() => { handleLogout(); setMobileMenuOpen(false); }}
                                        className="btn btn--outline-white btn--full"
                                    >
                                        Logout
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link to="/login" className="btn btn--outline-white btn--full" onClick={() => setMobileMenuOpen(false)}>
                                        Login
                                    </Link>
                                    <Link to="/register" className="btn btn--secondary btn--full" onClick={() => setMobileMenuOpen(false)}>
                                        Sign Up
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                )
            }
        </nav >
    )
}

export default Navbar
